<div class="modal-save-cart modal-fade">
  <div class="header">
    <div class="headline"><span class="headline-text">Guardar carrito</span></div>
    <span
      class="glyphicon glyphicon-remove cancel"
      (click)="close('Close Restore Cart Dialog')"
      (keydown.escape)="close('Close Restore Cart Dialog')"
    ></span>
  </div>
  <div class="content">
    <form [formGroup]="form">
      <label for="name"> NOMBRE </label>
      <input type="text"
             id="name" 
             name="name" 
             class="text form-control" 
             maxlength="255" 
             formControlName="name"
             (input)="updateRemainingCharsName($event, 'name')"
              />
      <div class="help-block right-cartName">Caracteres a la izquierda : {{remainingCharsName}}</div>

      <label for="description"> DESCRIPCIÓN </label>
      <textarea
        id="description"
        name="description"
        class="text form-control text-area"
        maxlength="255"
        formControlName="description"
        (input)="updateRemainingCharsDescription($event, 'description')"
      ></textarea>
      <div class="help-block right-cartName">Caracteres a la izquierda : {{remainingCharsDescription}}</div>

      <div class="modal-actions">
        <div class="row">
          <div class="col-12 col-sm-6 col-sm-pull-6">
            <button
              (click)="close('Close Restore Cart Dialog')"
              type="button"
              class="btn btn-default btn-block"
              [disabled]="isLoading$ | async"
            >
              Cancelar
            </button>
          </div>
          <div class="col-12 col-sm-6 col-sm-push-6">
            <button
              type="button"
              class="btn btn-primary btn-block"
              (click)="saveCart(cart?.code)"
              [disabled]="isLoading$ | async"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>